import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Axios instance with credentials so the session cookie is sent to the API
export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const fileUrl = (fileId) => (fileId ? `${API_BASE}/files/${fileId}` : null);
export const qrUrl = (data, size = 6) =>
  `${API_BASE}/qr?data=${encodeURIComponent(data)}&size=${size}`;
